// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
export const getUseBifrostGateway = () => window.USE_BIFROST_GATEWAY;
